import * as React from 'react';

import { WrappedFC } from '../shared/types';

interface CategoryProps {
  /** カテゴリのボタンのID */
  id: string;
  /** カテゴリの表示文字列 */
  label: string;
  /** 選択中か否か */
  isSelected?: boolean;
  /** クリック時のCallback */
  onClick: (e: React.MouseEvent) => void;
}

interface Props {
  /** 表示するカテゴリのリスト */
  categories: CategoryProps[];
  /** 表示するコンポーネントの種類 */
  type?: 'categories';
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';

/**
 * カテゴリ選択コンポーネント
 */
export const Categories: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type = 'categories',
  categories,
  className,
  onClick,
  'data-test': dataTest,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const categoriesComponent = categories.map((_category, index) => (
    <Category
      {..._category}
      data-test={`${dataTest}-${index}`}
      key={`${dataTest}-${index}`}
    />
  ));
  const _clsName = className || type;
  return (
    <Element {...props} className={_clsName} data-test={dataTest}>
      {categoriesComponent}
      {props.children}
    </Element>
  );
};
Categories.displayName = 'Categories';

/**
 * カテゴリ選択コンポーネントに載せるカテゴリコンポーネント
 */
const Category: WrappedFC<typeof DEFAULT_COMPONENT, CategoryProps> = ({
  isSelected,
  className,
  label,
  onClick,
  'data-test': dataTest,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _clsName = className || 'category' + (isSelected ? ' selected' : '');
  return (
    <Element
      {...props}
      className={_clsName}
      data-test={dataTest}
      onClick={onClick}
    >
      {label}
      {props.children}
    </Element>
  );
};
